import React, {useState} from 'react';
import {Button, Col, Form, Input, Modal, Row, Select, TimePicker} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import {User} from "../../../model/root/User";
import dayjs from "dayjs";
import ControlHorari from "../../../model/root/ControlHorari";
import toast, { Toaster } from 'react-hot-toast';


interface IngredientModalProps {
    element: ControlHorari;
    visible: boolean;
    onClose: (controlHorari: ControlHorari, guardar: boolean) => void;
    options: { label: string; value: string; }[];
    llocsTreball: { label: string; value: string; }[];
    usuaris: User[] | undefined;
    update: boolean;
}

const ControlHorariModal: React.FC<IngredientModalProps> = ({
                                                                element,
                                                                visible,
                                                                options,
                                                                onClose,
                                                                update,
                                                                llocsTreball
                                                            }) => {

    const [form] = Form.useForm();
    const format = 'HH:mm';
    const handleSubmit = () => {
        const formData = form.getFieldsValue();
        if (formData.entrada !== null && formData.sortida !== null) {
            const controlHorari = new ControlHorari(formData.id, formData.id, (idUsuari), formData.nom,
                formData.entrada.toString(), formData.sortida.toString(), formData.estat, (idLloc), formData.lloc);
            console.log(">>>>>"+JSON.stringify(controlHorari));
            onClose(controlHorari, true);
        } else {
           toast('Falten dades.');
        }

    };

    const [idLloc, setIdLloc] = useState(element.id_lloc);
    const [idUsuari, setIdUsuari] = useState(element.id_usuario);

    const filterOption = (input: string, options?: { label: string; value: string }) =>
        (options?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const handleCancel = () => {
        onClose(new ControlHorari(), false);
    };

    return (
        <>
            <Toaster />
            <Modal
                title="Editar Control Horari"
                open={visible}
                onCancel={handleCancel}
                footer={[
                    <>
                        <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                                onClick={handleSubmit}><BiCheck/></Button>
                        {" "}
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </>
                ]}
                width={300}
            >
                <Form form={form} initialValues={element}>
                    <Row gutter={[16, 16]}>
                        <Col span={42}>
                            <Form.Item label="ID" name="id">
                                <Input disabled/>
                            </Form.Item>
                            <Form.Item label="Nombre" name="nom" required>
                                <Select disabled={update}
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={filterOption}
                                        options={options}
                                        onChange={(text, index) => {
                                            setIdUsuari(text);
                                        }}
                                />
                            </Form.Item>
                            <Form.Item label="entrada" name="entrada" required>
                                <TimePicker defaultValue={dayjs('10:00', format)} format={format}/>
                            </Form.Item>
                            <Form.Item label="sortida" name="sortida" required>
                                {/*Se setea antes de que llegue al Modal el dayjs!!*/}
                                <TimePicker defaultValue={dayjs('17:00', format)} format={format}/>
                            </Form.Item>
                            <Form.Item label="Estado" name="estat" required>
                                <Select>
                                    <option value={0}>actiu</option>
                                    <option value={-1}>inactiu</option>
                                </Select>
                            </Form.Item>
                            <Form.Item label="Lloc" name="lloc" required>
                                <Select showSearch
                                        placeholder="Selecciona Lloc de treball"
                                        optionFilterProp="children"
                                        filterOption={filterOption}
                                        options={llocsTreball}
                                        onChange={(text, index) => {
                                            setIdLloc(text);
                                        }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
};

export default ControlHorariModal;
